import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Chip, TextField, Typography } from "@material-ui/core";
import { Button } from "components";
import { Controller, useForm } from "react-hook-form";
import KeyboardDatePicker from "shared/KeyboardDatePicker";

import { formStyles } from "./styles";
import { validationSchemaCreate } from "./validSchema";

export const Form = ({ productUnit, conferenceData, onSubmit }) => {
  const { handleSubmit, formState, reset, register, control } = useForm({
    resolver: yupResolver(validationSchemaCreate)
  });
  const { errors } = formState;

  const classes = formStyles();

  const handleResetFields = () => {
    reset();
  };

  const onSubmitHandler = data => {
    const formattedData = { ...data };

    // Formata a data para enviar apenas YYYY-MM-DD
    if (formattedData.invoice_issue_date) {
      const date = new Date(formattedData.invoice_issue_date);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      formattedData.invoice_issue_date = `${year}-${month}-${day}`;
    }

    onSubmit(formattedData);
    handleResetFields();
  };

  return (
    <Box component="form" onSubmit={handleSubmit(onSubmitHandler)}>
      <Box className={classes.formContainer}>
        {/* Campo Entrada - ReadOnly */}
        <Box className={classes.fieldGroup}>
          <Typography className={classes.fieldLabel}>Entrada</Typography>
          <Chip
            label={`${conferenceData?.batchInfos?.quantity} ${productUnit}s`}
            className={classes.chip}
          />
        </Box>

        {/* Campo Quantidade NF */}
        <Box className={classes.fieldGroup}>
          <Typography className={classes.fieldLabel}>Qntd. NF</Typography>
          <TextField
            variant="outlined"
            label="Inserir quantidade (opcional)"
            type="number"
            fullWidth
            {...register("quantity_invoice")}
            error={!!errors?.quantity_invoice}
            helperText={errors?.quantity_invoice?.message}
            defaultValue={
              conferenceData?.quantityInvoice ||
              conferenceData?.quantity_invoice
            }
            className={classes.textField}
          />
        </Box>

        {/* Campo Número da Nota Fiscal */}
        <Box className={classes.fieldGroup}>
          <Typography className={classes.fieldLabel}>
            Número da nota fiscal *
          </Typography>
          <TextField
            variant="outlined"
            label="Ex: 12345"
            type="text"
            fullWidth
            {...register("invoice_number")}
            error={!!errors?.invoice_number}
            helperText={errors?.invoice_number?.message}
            defaultValue={
              conferenceData?.invoiceNumber || conferenceData?.invoice_number
            }
            className={classes.textField}
            required
          />
        </Box>

        <Box className={classes.fieldGroup}>
          <Typography className={classes.fieldLabel}>
            Data de emissão da nota fiscal *
          </Typography>
          <Controller
            name="invoice_issue_date"
            control={control}
            defaultValue={(() => {
              const dateValue =
                conferenceData?.invoiceIssueDate ||
                conferenceData?.invoice_issue_date;
              if (dateValue) {
                if (
                  typeof dateValue === "string" &&
                  dateValue.match(/^\d{4}-\d{2}-\d{2}$/)
                ) {
                  const [year, month, day] = dateValue.split("-");
                  return new Date(
                    parseInt(year),
                    parseInt(month) - 1,
                    parseInt(day)
                  );
                }
                return new Date(dateValue);
              }
              return null;
            })()}
            render={({ field: { onChange, onBlur, value } }) => (
              <KeyboardDatePicker
                label="Selecione a data"
                fullWidth
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                inputVariant="outlined"
                views={["date"]}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                error={!!errors?.invoice_issue_date}
                helperText={errors?.invoice_issue_date?.message}
                className={classes.textField}
                required
              />
            )}
          />
        </Box>

        {/* Campo Observação */}
        <Box className={classes.fieldGroup}>
          <Typography className={classes.fieldLabel}>Observação</Typography>
          <TextField
            multiline
            rows={4}
            fullWidth
            defaultValue={conferenceData?.observation}
            {...register("observation")}
            error={!!errors?.observation}
            helperText={errors?.observation?.message}
            variant="outlined"
            placeholder="Adicione observações sobre a conferência..."
            className={classes.textField}
          />
        </Box>

        {/* Botão Salvar */}
        <Box className={classes.buttonContainer}>
          <Button
            variant="contained"
            type="submit"
            fullWidth
            className={classes.button}
          >
            Salvar
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
